import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["hideLabel", "label", "size", "truncateLabel"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { CHECKBOX_SIZES } from "../constants";
import { BREAKPOINTS, getRem, truncateText, typographyBody1, typographyBody2, visuallyHidden, wordBreak } from "./../../core";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledCheckboxLabel = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  align-self: center;\n  display: inline-flex;\n  line-height: ", ";\n  pointer-events: none;\n\n  @media ", " {\n    ", "\n    line-height: ", ";\n  }\n\n  ", "\n\n  ", "\n    ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return typographyBody2(theme);
}, getRem('20px'), BREAKPOINTS.L, function (_ref2) {
  var size = _ref2.size,
      theme = _ref2.theme;
  return size !== CHECKBOX_SIZES.LARGE && typographyBody1(theme);
}, getRem('20px'), function (_ref3) {
  var size = _ref3.size,
      theme = _ref3.theme;
  return size === CHECKBOX_SIZES.LARGE && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      ", "\n      line-height: ", ";\n    "])), typographyBody2(theme), getRem('20px'));
}, function (_ref4) {
  var hideLabel = _ref4.hideLabel;
  return hideLabel && visuallyHidden;
}, function (_ref5) {
  var truncateLabel = _ref5.truncateLabel;
  return truncateLabel ? css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          ", "\n          display: block;\n        "])), truncateText) : css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n          ", "\n          display: block;\n          width: 100%;\n        "])), wordBreak);
});

var CheckboxLabel = function CheckboxLabel(_ref6) {
  var hideLabel = _ref6.hideLabel,
      label = _ref6.label,
      size = _ref6.size,
      truncateLabel = _ref6.truncateLabel,
      other = _objectWithoutProperties(_ref6, _excluded);

  return /*#__PURE__*/_jsx(StyledCheckboxLabel, _objectSpread(_objectSpread({
    hideLabel: hideLabel,
    size: size,
    truncateLabel: truncateLabel
  }, other), {}, {
    children: label
  }));
};

CheckboxLabel.displayName = "CheckboxLabel";
CheckboxLabel.propTypes = {
  /** Visually hides checkbox label */
  hideLabel: PropTypes.bool,

  /** Checkbox label */
  label: PropTypes.node,

  /** Checkbox size */
  size: PropTypes.oneOf(Object.values(CHECKBOX_SIZES)),

  /** If true, truncates the label */
  truncateLabel: PropTypes.bool
};
CheckboxLabel.defaultProps = {
  hideLabel: false,
  label: '',
  size: CHECKBOX_SIZES.STANDARD,
  truncateLabel: false
};
export { CheckboxLabel };